/* eslint-disable react/prop-types */
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
  Typography,
  Select,
  notification,
  Tag,
  Row,
  Col,
  Upload,
} from 'antd';
import { get, set } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ExcelJS from 'exceljs';
import moment from 'moment';
import history from '../../services/history';
import ChatWindow from './ChatWindow';
import {
  ClearOutlined,
  CloudUploadOutlined,
  LoadingOutlined,
  UploadOutlined,
} from '@ant-design/icons';

import { authenticateCurrentUser } from '../../services/auth';
const { Option } = Select;
const { Title, Text } = Typography;

const AssistancePage = (props) => {
  const {} = props;
  const [fileList, setFileList] = useState([]);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clearChat, setClearChat] = useState(false);
  const [userName, setUserName] = useState('');
  const [userGroup, setUserGroup] = useState([]);
  const llm_url = process.env.REACT_APP_LMM_ASSISTANCE;

  /** get user Access */
  useEffect(() => {
    const UserGroup = localStorage.getItem('UserGroup');
    if (!UserGroup || UserGroup === '[]') {
      authenticateCurrentUser()
        .then(async (data) => {
          let response = await getAccess(data.username);
          const userAccess = response.map((item) => item?.GroupName);
          setUserName(data.username);
          setUserGroup(userAccess);
          localStorage.setItem('UserGroup', JSON.stringify(userAccess));
        })
        .catch((error) => {
          console.log('error', error);
        });
    } else {
      try {
        const parsedUserGroup = JSON.parse(UserGroup);
        setUserGroup(parsedUserGroup);
      } catch (error) {
        console.log('Error parsing UserGroup from localStorage:', error);
        setUserGroup([]);
      }
    }
  }, [history]);

  const handleFileUpload = async (file) => {
    setLoading(true);
    const fileUrl = URL.createObjectURL(file);
    setMessages((prev) => [...prev, { text: file.name, fileUrl, sender: 'user' }]);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch(`${llm_url}/upload`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer test-token',
          // Note: Do NOT set 'Content-Type' header here
        },
        body: formData,
      });

      const data = await res.json();
      console.log(data);
      const botMsg = { text: data.status || 'No response', sender: 'bot' };
      setMessages((prev) => [...prev, botMsg]);
    } catch (error) {
      console.error('Upload failed:', error);
      const botMsg = { text: 'Upload failed. Please try again.', sender: 'bot' };
      setMessages((prev) => [...prev, botMsg]);
    } finally {
      setLoading(false);
    }

    return false; // prevent auto-upload
  };

  // Upload props
  const fileProps = {
    multiple: true, // Allow multiple files
    fileList,
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf';
      if (!isPdf) {
        notification.warning({
          message: `Please select pdf file to upload..`,
          duration: 3,
        });
        return Upload.LIST_IGNORE; // Prevent non-PDF files from being added
      }
      setFileList((prev) => [...prev, file]);
      return false; // Prevent automatic upload
    },
    onRemove: (file) => {
      setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    },
    // accept: ".xlsx,.xls,.pdf", // Allow Excel & PDF files
    accept: '.pdf',
    maxCount: 100, // Allow up to 100 files
  };
  const handleUploadFile = async () => {
    if (fileList.length === 0) {
      notification.warning({
        message: `Please select at least one file to upload.`,
        duration: 3,
      });
      return;
    }

    setUploadLoading(true);
    setDisableFileUpload(false);
    setBulkUploadModal(false);

    const formData = new FormData();

    // Append each file to the FormData
    fileList.forEach((file) => {
      formData.append('files', file); // 'files' is the key expected by the backend
    });

    // const formData = new FormData();
    // formData.append('file', fileList[0]);

    try {
      const res = await fetch(`${llm_url}/upload`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer test-token',
          // Note: Do not set 'Content-Type' header; the browser will set it automatically
        },
        body: formData,
      });
      console.log(res);
      const data = await res.json();
      console.log(data);
      if (res.status == 200) {
        notification.success({
          message: 'Uploaded Successfully!.',
          duration: 3,
        });
      } else {
        notification.error({
          message: 'Failed to upload files.',
          duration: 3,
        });
      }

      // Reset the file list and related states
      setFileList([]);
    } catch (error) {
      console.error('Upload failed:', error);
      notification.error({
        message: 'Failed to upload files.',
        duration: 3,
      });
    } finally {
      setUploadLoading(false);
    }
  };

  console.log(userGroup, 'userGroup');
  return (
    <div className="d-flex flex-column h-100">
      <div className="flex-auto">
        <div className="flex-auto">
          {/* <div className='back_heatp_modal' >
                            <Tooltip title={'Back'} >
                                <ArrowLeftOutlined
                                    onClick={() => {
                                        history.push('/Assistance');
                                    }}
                                />
                            </Tooltip>
                        </div> */}
          <div className="d-flex mb-3 align-items-center tab-content-title">
            <Typography
              className="project-title"
              style={{ fontSize: '25px' }}
              level={4}
            >
              Ask Evans
            </Typography>

            <div className="new-calibration">
              {userGroup &&
                (userGroup.includes('askevans-training-data') ||
                  userGroup.includes('super-admin') ||
                  userGroup.includes('admin')) && (
                  <>
                    {uploadLoading ? (
                      <Text
                        className="ps-3 add-new-calibration"
                        loading={true}
                      >
                        <LoadingOutlined style={{ color: '#ef314c' }}></LoadingOutlined>
                        Train new data....
                      </Text>
                    ) : (
                      <Text
                        onClick={() => setBulkUploadModal(true)}
                        className="ps-3 add-new-calibration"
                        loading={true}
                      >
                        <span className="icon-22">
                          <UploadOutlined />
                        </span>
                        Train new data
                      </Text>
                    )}
                  </>
                )}
              <Text
                className="ps-3 add-new-calibration"
                onClick={() => setClearChat(true)}
              >
                <span
                  className="icon-22"
                  style={{ marginRight: '8px' }}
                >
                  <ClearOutlined />
                </span>
                Clear Chat
              </Text>
            </div>
          </div>
        </div>
        <div className="custom-line" />
        <ChatWindow clearChat={clearChat}></ChatWindow>
      </div>

      <Modal
        className="pipeline-modal"
        title="Upload Files"
        centered
        open={bulkUploadModal}
        onCancel={() => setBulkUploadModal(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setBulkUploadModal(false);
              setFileList([]);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="upload"
            type="primary"
            onClick={handleUploadFile}
            loading={uploadLoading}
          >
            Upload
          </Button>,
        ]}
      >
        <div className="uploadFile_admin">
          <Upload
            {...fileProps}
            accept=".pdf"
            multiple
            maxCount={10}
          >
            <Button
              disabled={disableFileUpload}
              icon={<CloudUploadOutlined />}
            >
              Select Files
            </Button>
          </Upload>
        </div>
      </Modal>
    </div>
  );
};

export default connect(null, null)(AssistancePage);
